import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useOpts } from '../../context';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { selectCurrentSource, selectLastSource, } from '../../state/slices/slice-segment';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import { usePIIDataContext } from '../../hooks/usePIIDataContext';
import { EventAction, EventType } from '../../types/events';
import PIITemplateForm from './PIITemplateForm';
import { getSelfIdNextRoute } from '../../utils/self-id-navigation';
var PIIDOBEntry = function () {
    var linkTokenPayload = useOpts().linkTokenPayload;
    var _a = usePIIDataContext(), setDob = _a.setDob, dob = _a.dob;
    var getLocalizedString = useGetLocalizedString();
    var fireUnifiedEvent = useOpts().fireUnifiedEvent;
    var navigate = useLinkNavigate();
    var currentSource = useSelector(selectCurrentSource);
    var lastSource = useSelector(selectLastSource);
    var handleSubmit = function (values) {
        setDob(values.dob);
        fireUnifiedEvent(EventType.LINK_COLLECT_PII_DATA_EVENT, {
            action: EventAction.CONTINUE,
            entry_point: lastSource,
            source: currentSource,
        });
        if (linkTokenPayload) {
            navigate(getSelfIdNextRoute(linkTokenPayload, '/pii-data/dob'));
        }
    };
    var dobField = useMemo(function () { return ({
        key: 'dob',
        label: getLocalizedString('BIRTHDATE'),
        fieldType: 'date3Inputs',
        required: true,
        fieldSubtype: 'plaintext',
        placeholder: 'MM/DD/YYYY',
    }); }, [getLocalizedString]);
    return (React.createElement(PIITemplateForm, { fieldConfigs: [dobField], initialValues: { dob: dob }, onSubmit: handleSubmit, contentFrameDataTestId: "PIIdobEntry", submitButtonEventId: "PIIData-dobEntry", subtitle: getLocalizedString('ENTER_YOUR_BIRTHDATE') }));
};
export default PIIDOBEntry;
